import { formatKaucja, type SkupPile } from "@ziolo/shared";
import { Button } from "@ziolo/ui";
import { playBottleSfx, unlockBottleSfx } from "./bottleSound.js";

function formatAway(ms: number): string {
  const sec = Math.max(1, Math.round(ms / 1000));
  if (sec < 60) return `${sec} s`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} min`;
  const hours = Math.floor(min / 60);
  const rest = min % 60;
  return rest === 0 ? `${hours} godz.` : `${hours} godz. ${rest} min`;
}

/** Greeting only. The bags themselves live on the butelkomat. */
export function SkupOverlay({
  pile,
  onHire,
  onClean,
}: {
  pile: SkupPile;
  onHire: () => void;
  /** Close the card so the pile on the machine can be clicked. */
  onClean: () => void;
}) {
  const haracz = pile.manualGrosze - pile.hireGrosze;

  return (
    <div className="skup-overlay" role="dialog" aria-label="Skup">
      <div className="skup-card">
        <p className="skup-card__kicker">Skup</p>
        <h2 className="skup-card__title">Syf na parkingu</h2>
        <p className="skup-card__copy">
          Twoi zbieracze zrobili syf na parkingu, musisz to posprzątać. Nie było Cię{" "}
          {formatAway(pile.ms)}
        </p>
        <p className="skup-card__approx">~{formatKaucja(pile.approximateGrosze)} w workach</p>
        <div className="skup-card__actions">
          <Button
            variant="primary"
            onClick={() => {
              unlockBottleSfx();
              playBottleSfx("ui");
              onClean();
            }}
          >
            Rozładuję sam!
          </Button>
          <Button
            variant="ghost"
            onClick={() => {
              unlockBottleSfx();
              playBottleSfx("hunt");
              onHire();
            }}
          >
            Wynajmij lokalnych meneli
          </Button>
          <p className="skup-card__hint">
            Wezmą swój haracz ({formatKaucja(haracz)}). Sam wyciągniesz więcej.
          </p>
        </div>
      </div>
    </div>
  );
}
